
import React from 'react';
import { Goonj2026 } from '../views';


const SchoolProgrampage = () => {
  return <Goonj2026/>;
};

export default SchoolProgrampage;